<template>
    <g class="label-group"
       :class="labelClass()"
       ref="label-boundingzoom">


        <!--- PAN VERTICAL && PAN VERTICAL -->
        <line
            :x1="labelPositionX()"
            :y1="labelPositionY()"
            :x2="labelPositionX() + imageWidth()"
            :y2="labelPositionY() + imageHeight()"
            class="label-bounding-line"
            v-if="label.panType !== 'pan_zoom'"
        />
    
        <!--- PAN HORIZONTAL -->
        <polygon v-if="label.panType === 'pan_vertical'" :points="triangleTop()" class="label-bounding-drag horizonal" @mousedown="startDragMove($event,'y')" @mouseup="stopDragMove()"/>
        <polygon v-if="label.panType === 'pan_vertical'" :points="triangleBottom()" class="label-bounding-drag horizonal" @mousedown="startDragMove($event,'y')" @mouseup="stopDragMove()"/>
        
        <!--- PAN VERTICAL -->
        <polygon v-if="label.panType === 'pan_horizontal'" :points="triangleLeft()" class="label-bounding-drag vertical" @mousedown="startDragMove($event,'x')" @mouseup="stopDragMove()"/>
        <polygon v-if="label.panType === 'pan_horizontal'" :points="triangleRight()" class="label-bounding-drag vertical" @mousedown="startDragMove($event,'x')" @mouseup="stopDragMove()"/>
    
        <!--- PAN ZOOM -->
        <rect class="label-drag-rect"
              :x="labelPositionX()"
              :y="labelPositionY()"
              :width="imageWidth()+'px'" :height="imageHeight()+'px'" rx="3" ry="3"
              v-if="label.panType === 'pan_zoom'"
        />
        <rect class="label-boundingzoom-rect"
              :x="labelPositionX()"
              :y="labelPositionY()"
              :width="imageWidth()+'px'" :height="imageHeight()+'px'"
              @mouseleave="stopDragDelay"
              @mousedown="startDrag($event)"
              @mouseup="stopDrag()"
              ref="label-boundingzoom-rect"
              v-if="label.panType === 'pan_zoom'"
        />

            <circle
                v-if="label.panType === 'pan_zoom'"
                :cx="labelPositionX()"
                :cy="labelPositionY()"
                :r="8"
                class="resize-select top-left"
                :class="{'drag':dragResize === 'x1y1'}"
                @mousedown="startDragResize($event,'x1y1')"
                @mouseup="stopDragResize()"
                ref="label-overlays-resize"
            />
            <circle
                v-if="label.panType === 'pan_zoom'"
                :cx="labelPositionX() + imageWidth()"
                :cy="labelPositionY()"
                :r="8"
                class="resize-select top-right"
                :class="{'drag':dragResize === 'x2y1'}"
                @mousedown="startDragResize($event,'x2y1')"
                @mouseup="stopDragResize()"
                ref="label-overlays-resize"
            />
            <circle
                v-if="label.panType === 'pan_zoom'"
                :cx="labelPositionX() + imageWidth()"
                :cy="labelPositionY() + imageHeight()"
                :r="8"
                class="resize-select bottom-right"
                :class="{'drag':dragResize === 'x2y2'}"
                @mousedown="startDragResize($event,'x2y2')"
                @mouseup="stopDragResize()"
                ref="label-overlays-resize"
            />
            <circle
                v-if="label.panType === 'pan_zoom'"
                :cx="labelPositionX()"
                :cy="labelPositionY() + imageHeight()"
                :r="8"
                class="resize-select bottom-left"
                :class="{'drag':dragResize === 'x1y2'}"
                @mousedown="startDragResize($event,'x1y2')"
                @mouseup="stopDragResize()"
                ref="label-overlays-resize"
            />
    </g>
</template>

<script>
    import Tools from "../../class/tools";
    import events from "@/events/events";

    export default {
        name: "BoundingZoom_Pointer",
        props: {
            label: {},
            imageData: {type: Object},
            selected: {type: Boolean},
            hovered: {type: Boolean}
        },
        data() {
            return {
                start: false,
                drag: false,
                dragResize: "",
                dragMove: "",
                dragPointer: false,
                dragOffset: {
                    x: 0,
                    y: 0
                },
                imageRatio: 0,
                pointerCSS: "",
            }
        },
        methods: {
            startDrag($event) {
                this.start = true;
                setTimeout(() => {
                    if (this.start) {
                        this.drag = true;
                        this.dragResize = ""
                
                        this.dragOffset.x = $event.pageX - this.$refs["label-boundingzoom-rect"].getBoundingClientRect().left;
                        this.dragOffset.y = $event.pageY - this.$refs["label-boundingzoom-rect"].getBoundingClientRect().top;
                
                        this.$emit('drag');
                        events.$on("body:click:mouse:up",this.stopDrag)
                    }
                }, this.$store.getters.getDelayBeforeDrag)
            },
            startDragMove($event,type){
                this.dragMove = type;
                this.drag = false;
                this.dragOffset.x = 0;
                this.dragOffset.y = 0;
                this.$emit('drag');
                events.$on("body:click:mouse:up",this.stopDragMove)
            },
            startDragResize($event, type) {
                this.dragResize = type;
                this.drag = false;
                this.dragOffset.x = 0;
                this.dragOffset.y = 0;
                this.$emit('drag');
                events.$on("body:click:mouse:up",this.stopDragResize)
            },
            stopDrag() {
                this.start = false;
    
                if(this.drag){
                    events.$emit("interactive-image:"+this.label.interactiveImageId+":boundingzone:save")
                }
                
                this.drag = false;
                this.$emit('undrag');
                events.$off("body:click:mouse:up",this.stopDrag)
            },
            stopDragDelay(){
                if(this.start && !this.drag){
                    this.start = false;
                    this.drag = false;
                    this.$emit('unselect');
                }
                if(!this.drag){
                    this.$emit('unhover')
                }
            },
            stopDragMove(){
                this.dragMove = "";
                this.$emit('undrag');
    
                events.$emit("interactive-image:"+this.label.interactiveImageId+":boundingzone:save")
                events.$off("body:click:mouse:up",this.stopDragMove)
                
            },
            stopDragResize() {
                this.dragResize = "";
                this.$emit('undrag');
    
                events.$emit("interactive-image:"+this.label.interactiveImageId+":boundingzone:save")
                events.$off("body:click:mouse:up",this.stopDragResize)
            },
            labelClass() {

                let classe = this.label.getObjectType();
                if (this.start) {
                    classe += " start ";
                }
                if (this.drag) {
                    classe += " drag ";
                }
                if (this.selected) {
                    classe += " select ";
                }
                if (this.hovered) {
                    classe += " hover ";
                }

                return classe
            },
            labelPositionX() {
                let x = parseFloat(this.label.x_coord);
                x *= this.imageData.ratioX;
                return x;
            },
            labelPositionY() {
                let y = parseFloat(this.label.y_coord);
                y *= this.imageData.ratioY;
                return y;
            },
            imageWidth() {
                let width = parseFloat(this.label.width);
                width *= this.imageData.ratioX;
                return width;
            },
            imageHeight() {
                let height = parseFloat(this.label.height);
                height *= this.imageData.ratioY;
                return height;

            },
            triangleTop(){
                return ((this.imageWidth() / 2) + 20)+','+this.labelPositionY()+' '+((this.imageWidth() / 2) - 20)+','+this.labelPositionY()+' '+(this.imageWidth() / 2)+','+(this.labelPositionY() - 20)
            },
            triangleBottom(){
                return ((this.imageWidth() / 2) + 20)+','+(this.labelPositionY())+' '+((this.imageWidth() / 2) - 20)+','+(this.labelPositionY())+' '+(this.imageWidth() / 2)+','+(this.labelPositionY() + 20)
            },
            triangleLeft(){
                return this.labelPositionX()+','+((this.imageHeight() / 2) - 20)+' '+this.labelPositionX()+','+((this.imageHeight() / 2) + 20)+' '+(this.labelPositionX() - 20)+','+((this.imageHeight() / 2))
            },
            triangleRight(){
                return this.labelPositionX()+','+((this.imageHeight() / 2) - 20)+' '+this.labelPositionX()+','+((this.imageHeight() / 2) + 20)+' '+(this.labelPositionX() + 20)+','+((this.imageHeight() / 2))
            },
        },
        computed: {
            hasPointer() {
                return this.label.pointer_x_coord !== 0 && this.label.pointer_y_coord !== 0;
            }
        },
        watch: {
            '$store.state.mouse.position'(value) {

                let label = this.label;

                // drag rect
                if(this.drag){
                    label.x_coord = Tools.format(value.x - this.dragOffset.x,0, this.imageData.width - (label.width * this.imageData.ratioX),this.imageData.ratioX);
                    label.y_coord = Tools.format(value.y - this.dragOffset.y,0, this.imageData.height - (label.height * this.imageData.ratioY),this.imageData.ratioY);
                }
                
                // drag pointer
                if (this.dragResize !== "") {
                    
                    let mouseX = value.x
                    let mouseY = value.y
                    if(mouseX < this.imageData.width * 0.03){mouseX = 0}
                    if(mouseX > this.imageData.width * 0.97){mouseX = this.imageData.width}
                    if(mouseY < this.imageData.height * 0.03){mouseY = 0}
                    if(mouseY > this.imageData.height * 0.97){mouseY = this.imageData.height}
                    
                    let newWidth = mouseX - this.labelPositionX();
                    let newHeight = mouseY - this.labelPositionY();
                    
                    if(this.dragResize === "x1y1"){
                        label.width = label.x_coord - Tools.format(mouseX - this.dragOffset.x,0, this.imageData.width,this.imageData.ratioX) + label.width;
                        
                        if(label.width < this.imageData.imgWidth * 0.1){
                            label.width = this.imageData.imgWidth * 0.1
                        }else {
                            label.x_coord = Tools.format(mouseX - this.dragOffset.x, 0, this.imageData.width, this.imageData.ratioX);
                        }
    
                        label.height = label.y_coord - Tools.format(mouseY - this.dragOffset.y,0, this.imageData.height,this.imageData.ratioY) + label.height;
                        
                        if(label.height < this.imageData.imgHeight * 0.1){
                            label.height = this.imageData.imgHeight * 0.1
                        }else {
                            label.y_coord = Tools.format(mouseY - this.dragOffset.y, 0, this.imageData.height, this.imageData.ratioY);
                        }
                    }
                    
                    if(this.dragResize === "x2y1"){
                        label.width = newWidth;
                        if(label.width < 0) label.width = 0;
                        label.width /= this.imageData.ratioX;
    
                        label.height = label.y_coord - Tools.format(mouseY - this.dragOffset.y,0, this.imageData.height,this.imageData.ratioY) + label.height;
                        if(label.height < this.imageData.imgHeight * 0.1){
                            label.height = this.imageData.imgHeight * 0.1
                        }else {
                            label.y_coord = Tools.format(mouseY - this.dragOffset.y,0, this.imageData.height,this.imageData.ratioY);
                        }
                    }
                    
                    if(this.dragResize === "x1y2"){
                        label.height = newHeight;
                        if(label.height < 0) label.height = 0;
                        label.height /= this.imageData.ratioY;
                        
                        label.width = label.x_coord - Tools.format(mouseX - this.dragOffset.x,0, this.imageData.width,this.imageData.ratioX) + label.width;
                        if(label.width < this.imageData.imgWidth * 0.1){
                            label.width = this.imageData.imgWidth * 0.1
                        }else {
                            label.x_coord = Tools.format(mouseX - this.dragOffset.x,0, this.imageData.width,this.imageData.ratioX);
                        }
                    }
                    
                    if(this.dragResize === "x2y2"){
                        label.height = newHeight;
                        if(label.height < 0) label.height = 0;
                        label.height /= this.imageData.ratioY;
    
                        label.width = newWidth;
                        if(label.width < 0) label.width = 0;
                        label.width /= this.imageData.ratioX;
                    }
                    
                    if(label.width < this.imageData.imgWidth * 0.1){
                        label.width = this.imageData.imgWidth * 0.1
                    }
                    if(label.height < this.imageData.imgHeight * 0.1){
                        label.height = this.imageData.imgHeight * 0.1
                    }
                    
                    label.width = Math.round(label.width);
                    label.height = Math.round(label.height);
                }
                
                if(this.dragMove !== ""){
                    if(this.dragMove === "x"){
                        label.x_coord = Tools.format(value.x - this.dragOffset.x,0, this.imageData.width,this.imageData.ratioX);
                        // magnetisme
                        if(label.x_coord < this.imageData.imgWidth * 0.03){label.x_coord = 0}
                        if(label.x_coord > this.imageData.imgWidth - (this.imageData.imgWidth * 0.03)){label.x_coord = this.imageData.imgWidth}
                    }
                    if(this.dragMove === "y"){
                        label.y_coord = Tools.format(value.y - this.dragOffset.y,0, this.imageData.height,this.imageData.ratioY);
                        // magnetisme
                        if(label.y_coord < this.imageData.imgHeight * 0.03){label.y_coord = 0}
                        if(label.y_coord > this.imageData.imgHeight - (this.imageData.imgHeight * 0.03)){label.y_coord = this.imageData.imgHeight}
                    }
                }
            },
            'imageData.zoom'(){
                this.$forceUpdate();
            },
            'imageData.width'(){
                this.$forceUpdate();
            },
            'imageData.height'(){
                this.$forceUpdate();
            },
        },
        mounted() {
            console.log(this.label)
        }
    }
</script>